/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfig } from '@core/lib/components/modal/modal-config';
import { ModalRef } from '@core/lib/components/modal/modal-ref';

@Component({
  selector: 'app-archive-adopted-modal',
  templateUrl: './archive-adopted-modal.component.html'
})
export class ArchiveAdoptedModalComponent implements OnInit {
  labelViewImagesOnly;
  bodyContent;
  labelNo;
  labelYes;

  constructor(public config: ModalConfig, public modalRef: ModalRef, private translate: TranslateService) {}

  onClose(event, value) {
    event.stopPropagation();
    this.modalRef.close(value);
  }

  ngOnInit(): void {
    if (this.config.data.isDownloadable) {
      this.labelViewImagesOnly = this.translate.instant('workloadManager.listContainer.worklist.viewImagesOnlyBtn');
      this.bodyContent = this.translate.instant('workloadManager.listContainer.worklist.bringExamOnlineMsg');
      this.labelNo = this.translate.instant('label.cancel');
      this.labelYes = this.translate.instant('workloadManager.listContainer.worklist.bringExamOnlineBtn');
    } else {
      this.bodyContent = this.translate.instant('workloadManager.listContainer.worklist.cannotBringExamOnlineMsg');
      this.labelNo = this.translate.instant('label.OK');
      this.labelYes = '';
    }
  }
}
